(function (Namespace)
{
	/********************************************
	*
	* Start - Sort Argument
	*
	********************************************/

	Namespace.ScreenerUtility.ScreenInputs.SortArgument = function (Field, Direction)
	{
		this._Type = "SortArgument";

		this._Data = {
			Field: "",
			Direction: 0
		};

		this.SetField(Field);
		this.SetDirection(Direction);

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.SortArgument.fn = Namespace.ScreenerUtility.ScreenInputs.SortArgument.prototype;

	Namespace.ScreenerUtility.ScreenInputs.SortArgument.fn.SetField = function (Field)
	{
		this._Data.Field = Field;

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.SortArgument.fn.SetDirection = function (Direction)
	{
		if (!Namespace.ScreenerUtility.IsValidSortDirection(Direction))
		{
			throw ("Error occured in ScreenInputs.SortArgument.SetDirection(Direction): SortDirection cannot be null and must be type of ScreenerUtility.SORT_DIRECTION.");
		}

		this._Data.Direction = Direction;

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.SortArgument.fn.GetData = function ()
	{
		return this._Data;
	};

	/********************************************
	*
	* End - Sort Argument
	*
	********************************************/

	/*-----------------------------------------*/

	/********************************************
	*
	* Start - Argument
	*
	********************************************/

	Namespace.ScreenerUtility.Argument = function ()
	{
		this._Type = "Argument";
		this._SafeName = "";

		this._Data = {
			ArgsOperator: null,
			ValueOperator: null,
			Arguments: [],
			Clauses: [],
			ClauseGroups: [],
			Field: "",
			Identifiers: [],
			Style: ""
		};

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn = Namespace.ScreenerUtility.Argument.prototype;

	Namespace.ScreenerUtility.Argument.fn.Parse = function (Input, bFieldAndSafeNameAreTheSame)
	{
		// turn it into an object if you can.
		if (typeof (Input) == "string") { Input = JSON.parse(Input); }

		if (Input.ArgsOperator)
		{
			this._Data.ArgsOperator = Input.ArgsOperator;
		}

		if (Input.ValueOperator)
		{
			this._Data.ValueOperator = Input.ValueOperator;
		}

		if (Input.Identifiers)
		{
			this._Data.Identifiers = Input.Identifiers;
		}

		if (Input.Style)
		{
			this._Data.Style = Input.Style;
		}

		if (Input.Field)
		{
			this._Data.Field = Input.Field;

			if (bFieldAndSafeNameAreTheSame)
			{
				this.SetSafeName(Input.Field);
			}
		}

		if (Input.Arguments)
		{
			for (var i = 0, j = Input.Arguments.length; i < j; i++)
			{
				var Arg = new Namespace.ScreenerUtility.Argument();

				Arg.Parse(Input.Arguments[i]);

				this.AddArgument(Arg);
			}
		}

		if (Input.Clauses)
		{
			for (var i = 0, j = Input.Clauses.length; i < j; i++)
			{
				var Clause = new Namespace.ScreenerUtility.Argument.Clause();

				Clause.Parse(Input.Clauses[i]);

				this.AddClause(Clause);
			}
		}

		if (Input.ClauseGroups)
		{
			for (var i = 0, j = Input.ClauseGroups.length; i < j; i++)
			{
				var ClauseGroup = new Namespace.ScreenerUtility.Argument.ClauseGroups();

				ClauseGroup.Parse(Input.ClauseGroups[i]);

				this.AddClauseGroup(ClauseGroup);
			}
		}

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.AddClause = function (Clause)
	{
		if (Clause && Clause._Type == "Clause")
		{
			this._Data.Clauses.push(Clause);
		}
		else
		{
			throw ("Error occured in ScreenerUtility.Argument.AddClause(Cluase): Argument can not be null and must be an instance of ScreenerUtility.Argument.Clause. Please check your input and try again.");
		}

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.RemoveAllClauses = function ()
	{
		this._Data.Clauses = [];

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.RemoveClauseAt = function (iIndex)
	{
		// if index is out of range just ignore it
		if (iIndex < this._Data.Clauses.length && (this._DataClauses[iIndex] || this._DataClauses[iIndex] == 0))
		{
			this._Data.Clauses.splice(iIndex, 1);
		}
		else
		{
			throw ("Error occured in Argument.RemoveClauseAt(iIndex): iIndex was out of range or null. Check your inputs and try again.");
		}

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.RemoveClauseByValue = function (sValue, bAllInstances)
	{
		if (!sValue || $.trim(sValue) == "")
		{
			throw ("Error occured in Argument.RemoveClauseByValue(sValue, bAllInstances): sValue is  null or empty. Check your inputs and try again.");
		}

		var arClausesToKeep = [];
		var bFoundFirst = false;

		for (var i = 0, j = this._Data.Clauses.length; i < j; i++)
		{
			var objCurrClause = this._Data.Clauses[i];

			// if we already found the first instance and we don't want to remove all instances
			if (bFoundFirst && !bAllInstances)
			{
				arClausesToKeep.push(objCurrClause);
				continue;
			}

			if (objCurrClause._Data && objCurrClause._Data.Values && objCurrClause._Data.Values.length > 0)
			{
				if (
					(objCurrClause._Data.Values.length == 1 && objCurrClause._Data.Values == sValue) ||
					(objCurrClause._Data.Values.length > 1 && objCurrClause._Data.Values.join("|~|").indexOf(sValue + "|~|") > -1)
				)
				{
					bFoundFirst == true;
					continue;
				}
			}

			arClausesToKeep.push(objCurrClause);
		}

		// set the clauses we want to keep
		this._Data.Clauses = arClausesToKeep;

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.GetClauses = function ()
	{
		return this._Data.Clauses;
	};

	Namespace.ScreenerUtility.Argument.fn.AddClauseGroup = function (ClauseGroup)
	{
		if (ClauseGroup && ClauseGroup.length)
		{
			this._Data.ClauseGroups.push(ClauseGroup);
		}
		else
		{
			throw ("Error occured in ScreenerUtility.Argument.AddClauseGroup(ClauseGroup): Argument can not be null and must be an array containing instances of ScreenerUtility.Argument.Clause. Please check your input and try again.");
		}

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.RemoveAllClauseGroups = function ()
	{
		this._Data.ClauseGroups = [];

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.SetSafeName = function (sName)
	{
		this._SafeName = sName;

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.GetStyle = function ()
	{
		return this._Data.Style;
	};

	Namespace.ScreenerUtility.Argument.fn.SetStyle = function (sStyle)
	{
		this._Data.Style = sStyle;

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.GetIdentifiers = function ()
	{
		return this._Data.Identifiers;
	};

	Namespace.ScreenerUtility.Argument.fn.SetIdentifiers = function (arIdentifiers)
	{
		this._Data.Identifiers = arIdentifiers || [];

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.AddIdentifier = function (sIdentifier)
	{
		this._Data.Identifiers.push(sIdentifier);
		
		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.RemoveIdentifier = function (sIdentifier)
	{
		if (!this._Data.Identifiers)
		{
			return this;
		}
		
		var arNewIdentifiers = [];

		for (var i = 0, j = this._Data.Identifiers.lenght; i < j; i++)
		{
			if (this._Data.Identifier[i] != sRemove)
			{
				arNewIdentifiers.push(this._Data.Identifier[i]);
			}
		}

		this._Data.Identifiers = arNewIdentifiers;

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.SetArgsOperator = function (ArgsOperator)
	{
		if ((!ArgsOperator && ArgsOperator != 0) || !Namespace.ScreenerUtility.IsValidOperator(ArgsOperator))
		{
			throw ("Error occured in ScreenerUtility.Argument.SetArgsOperator(ArgsOperator): ArgsOperator is a required input and must be one of ScreenerUtility.ARGS_OPERATORS. Please check your inputs and try again");
		}
		else
		{
			this._Data.ArgsOperator = ArgsOperator;
		}

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.SetValueOperator = function (ValueOperator)
	{
		if ((!ValueOperator && ValueOperator != 0) || !Namespace.ScreenerUtility.IsValidArgOrValueOperator(ValueOperator))
		{
			throw ("Error occured in ScreenerUtility.Argument.SetValueOperator(ValueOperator): ValueOperator is a required input and must be one of ScreenerUtility.VALUE_OPERATORS. Please check your inputs and try again");
		}
		else
		{
			this._Data.ValueOperator = ValueOperator;
		}

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.SetField = function (sField)
	{
		this._Data.Field = sField;

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.GetArgsOperator = function ()
	{
		return this._Data.ArgsOperator;
	};

	Namespace.ScreenerUtility.Argument.fn.GetValueOperator = function ()
	{
		return this._Data.ValueOperator;
	};

	Namespace.ScreenerUtility.Argument.fn.GetField = function ()
	{
		return this._Data.Field;
	};

	Namespace.ScreenerUtility.Argument.fn.GetSafeName = function ()
	{
		return this._SafeName;
	};

	Namespace.ScreenerUtility.Argument.fn.AddArgument = function (Argument)
	{
		if (Argument && Argument._Type == "Argument")
		{
			this._Data.Arguments.push(Argument);
		}
		else
		{
			throw ("Error occured in ScreenerUtility.Argument.AddArgument(Argument): Argument can not be null and must be an instance of ScreenerUtility.Argument. Please check your input and try again.");
		}

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.RemoveAllArguments = function ()
	{
		this._Data.Arguments = [];

		return this;
	};

	Namespace.ScreenerUtility.Argument.fn.GetData = function ()
	{
		var ReturnObj = {};

		$.extend(true, ReturnObj, this._Data);

		ReturnObj.Arguments = [];

		for (var i = 0, j = this._Data.Arguments.length; i < j; i++)
		{
			ReturnObj.Arguments.push(this._Data.Arguments[i].GetData());
		}

		ReturnObj.Clauses = [];

		for (var i = 0, j = this._Data.Clauses.length; i < j; i++)
		{
			ReturnObj.Clauses.push(this._Data.Clauses[i].GetData());
		}

		ReturnObj.ClauseGroups = [];

		for (var i = 0, j = this._Data.ClauseGroups.length; i < j; i++)
		{
			var arClauseGroup = [];

			for (var it = 0, jt = this._Data.ClauseGroups[i]; it < jt; it++)
			{
				arClauseGroup.push(this._Data.ClauseGroups[i][it].GetData());
			}

			ReturnObj.ClauseGroups.push(arClauseGroup);
		}

		return ReturnObj;
	};

	/********************************************
	*
	* End - Argument
	*
	********************************************/

	Namespace.ScreenerUtility.Argument.Clause = function (Operator, Values)
	{
		this._Type = "Clause";

		this._Data = {
			Operator: null,
			Values: []
		};

		this.SetOperator(Operator, true);
		this.SetValues(Values, true);

		return this;
	};

	Namespace.ScreenerUtility.Argument.Clause.fn = Namespace.ScreenerUtility.Argument.Clause.prototype;

	Namespace.ScreenerUtility.Argument.Clause.fn.Parse = function (Input)
	{
		if (typeof (Input) == "string") { Input = JSON.parse(Input); }

		this._Data = {
			Operator: (Input.Operator || Input.Operator == 0) ? Input.Operator : null,
			Values: Input.Values || []
		};

		return this;
	};

	Namespace.ScreenerUtility.Argument.Clause.fn.SetOperator = function (Operator, bDoNotThrowError)
	{
		if (!bDoNotThrowError && (!Operator || !Namespace.ScreenerUtility.IsValidOperator(Operator)))
		{
			throw ("Error occured in ScreenerUtility.Argument.Clause.SetOperator(Operator, bDoNotThrowError): Operator is a required input and must be one of ScreenerUtility.OPERATORS. Please check your inputs and try again");
		}

		this._Data.Operator = Operator;

		return this;
	};

	Namespace.ScreenerUtility.Argument.Clause.fn.SetValues = function (arValues, bDoNotThrowError)
	{
		if (!bDoNotThrowError && (!arValues || !arValues.length))
		{
			throw ("Error occured in ScreenerUtility.Argument.Clause.SetValues(arValues, bDoNotThrowError): arValues is a required input and must be an array of values. Please check your inputs and try again");
		}

		this._Data.Values = arValues;

		return this;
	};

	Namespace.ScreenerUtility.Argument.Clause.fn.AddValue = function (sValue)
	{
		this._Data.Values.push(sValue);

		return this;
	};

	Namespace.ScreenerUtility.Argument.Clause.fn.GetOperator = function ()
	{
		return this._Data.Operator;
	};

	Namespace.ScreenerUtility.Argument.Clause.fn.GetValues = function ()
	{
		return this._Data.Values;
	};

	Namespace.ScreenerUtility.Argument.Clause.fn.GetData = function ()
	{
		return this._Data;
	};
})(window.MOD || window.WSOD || window);